import { motion } from "framer-motion";

export default function Waveform({ levels = [], active = false }) {
    return (
        <div className="flex items-center justify-center gap-[3px] h-16" data-testid="waveform">
            {levels.map((h, i) => (
                <motion.span
                    key={i}
                    className="w-[3px] rounded-full bg-terracotta/80 dark:bg-terracotta"
                    initial={{ height: 4 }}
                    animate={{ height: active ? Math.max(4, h) : 4 + Math.sin(i) * 2 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                />
            ))}
        </div>
    );
}
